import { createSlice } from '@reduxjs/toolkit';

import socket from '../../utils/socket';

const initialState = {
  isLoading: false,
  error: false,
  // datas
  links: []
};

const slice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },

    getLinks(state, action) {
      const { links } = action.payload;
      state.isLoading = false;
      state.links = links;
    }
  }
});

// Reducer
export default slice.reducer;

export function getLinks() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/links');
      dispatch(slice.actions.getLinks(result));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
